import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { apiKeysQueryOptions } from "@/app/api-keys/api/get-api-keys";
import { ApiKeysListSkeleton } from "@/app/api-keys/components/api-keys-list-skeleton";
import { ApiKeysList } from "@/app/api-keys/list";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/api-keys"
)({
  component: () => (
    <Suspense fallback={<ApiKeysListSkeleton />}>
      <ApiKeysList />
    </Suspense>
  ),
  beforeLoad: ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(
      apiKeysQueryOptions({
        organizationId: params.organizationId,
        projectId: params.projectId,
      })
    );
  },
  loader: () => ({
    crumb: "API Keys",
  }),
});
